//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
SPLM.Point3d = class{
    constructor(x,y,z){
        this.x=x;this.y=y;this.z=z;}
    get X(){return this.x}
    set X(val){this.x = val}
    get Y(){return this.y}
    set Y(val){this.y = val}
    get Z(){return this.z}
    set Z(val){this.z = val}
};

SPLM.Vector3d = class{
    constructor(x,y,z){
        this.x=x;this.y=y;this.z=z;}
    get X(){return this.x}
    set X(val){this.x = val}
    get Y(){return this.y}
    set Y(val){this.y = val}
    get Z(){return this.z}
    set Z(val){this.z = val}
};

SPLM.Matrix3x3 = class{
    constructor(xx,xy,xz,yx,yy,yz,zx,zy,zz){
        this.xx=xx;this.xy=xy;this.xz=xz;this.yx=yx;this.yy=yy;this.yz=yz;this.zx=zx;this.zy=zy;this.zz=zz;}
    get Xx(){return this.xx}
    set Xx(val){this.xx = val}
    get Xy(){return this.xy}
    set Xy(val){this.xy = val}
    get Xz(){return this.xz}
    set Xz(val){this.xz = val}
    get Yx(){return this.yx}
    set Yx(val){this.yx = val}
    get Yy(){return this.yy}
    set Yy(val){this.yy = val}
    get Yz(){return this.yz}
    set Yz(val){this.yz = val}
    get Zx(){return this.zx}
    set Zx(val){this.zx = val}
    get Zy(){return this.zy}
    set Zy(val){this.zy = val}
    get Zz(){return this.zz}
    set Zz(val){this.zz = val}
};

SPLM.Point2d = class{
    constructor(x,y){
        this.x=x;this.y=y;}
    get X(){return this.x}
    set X(val){this.x = val}
    get Y(){return this.y}
    set Y(val){this.y = val}
};

SPLM.Vector2d = class{
    constructor(x,y){
        this.x=x;this.y=y;}
    get X(){return this.x}
    set X(val){this.x = val}
    get Y(){return this.y}
    set Y(val){this.y = val}
};

SPLM.Point4d = class{
    constructor(x,y,z,w){
        this.x=x;this.y=y;this.z=z;this.w=w;}
    get X(){return this.x}
    set X(val){this.x = val}
    get Y(){return this.y}
    set Y(val){this.y = val}
    get Z(){return this.z}
    set Z(val){this.z = val}
    get W(){return this.w}
    set W(val){this.w = val}
};

SPLM.Matrix4x4 = class{
    constructor(rxx,rxy,rxz,xt,ryx,ryy,ryz,yt,rzx,rzy,rzz,zt,sx,sy,sz,ss){
        this.rxx=rxx;this.rxy=rxy;this.rxz=rxz;this.xt=xt;this.ryx=ryx;this.ryy=ryy;this.ryz=ryz;this.yt=yt;this.rzx=rzx;this.rzy=rzy;this.rzz=rzz;this.zt=zt;this.sx=sx;this.sy=sy;this.sz=sz;this.ss=ss;}
    get Rxx(){return this.rxx}
    set Rxx(val){this.rxx = val}
    get Rxy(){return this.rxy}
    set Rxy(val){this.rxy = val}
    get Rxz(){return this.rxz}
    set Rxz(val){this.rxz = val}
    get Xt(){return this.xt}
    set Xt(val){this.xt = val}
    get Ryx(){return this.ryx}
    set Ryx(val){this.ryx = val}
    get Ryy(){return this.ryy}
    set Ryy(val){this.ryy = val}
    get Ryz(){return this.ryz}
    set Ryz(val){this.ryz = val}
    get Yt(){return this.yt}
    set Yt(val){this.yt = val}
    get Rzx(){return this.rzx}
    set Rzx(val){this.rzx = val}
    get Rzy(){return this.rzy}
    set Rzy(val){this.rzy = val}
    get Rzz(){return this.rzz}
    set Rzz(val){this.rzz = val}
    get Zt(){return this.zt}
    set Zt(val){this.zt = val}
    get Sx(){return this.sx}
    set Sx(val){this.sx = val}
    get Sy(){return this.sy}
    set Sy(val){this.sy = val}
    get Sz(){return this.sz}
    set Sz(val){this.sz = val}
    get Ss(){return this.ss}
    set Ss(val){this.ss = val}
};

export default SPLM;